import { render, staticRenderFns } from "./itemStatisticsCopy.vue?vue&type=template&id=45ca55a4&scoped=true&"
import script from "./itemStatisticsCopy.vue?vue&type=script&lang=js&"
export * from "./itemStatisticsCopy.vue?vue&type=script&lang=js&"
import style0 from "./itemStatisticsCopy.vue?vue&type=style&index=0&id=45ca55a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca55a4",
  null
  
)

export default component.exports